export { default } from '../../src/pages/Article'
